import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { CREDIT } from "@/data/site";

const KEY = "treffe_cookie_consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (!saved) setTimeout(() => setVisible(true), 1200);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 28 }}
          className="fixed bottom-24 md:bottom-6 left-4 right-4 md:left-6 md:right-auto md:max-w-sm z-[85] bg-brand-black text-white p-5 border border-white/10 shadow-2xl"
        >
          <div className="flex items-start gap-3 mb-4">
            <Cookie size={22} className="text-brand-red shrink-0 mt-0.5" />
            <p className="text-sm text-white/80 leading-relaxed">
              Usiamo cookie tecnici e di misurazione per migliorare la tua
              esperienza. Continuando accetti la nostra{" "}
              <Link to="/privacy" className="underline hover:text-white" data-testid="cookie-privacy-link">
                Privacy &amp; Cookie Policy
              </Link>.
            </p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={() => decide("accepted")}
              data-testid="cookie-accept"
              className="flex-1 bg-brand-red text-white font-bold uppercase tracking-widest text-xs px-5 py-3 hover:bg-white hover:text-brand-black transition-colors"
            >
              Accetta
            </button>
            <button
              onClick={() => decide("rejected")}
              data-testid="cookie-reject"
              className="flex-1 border border-white/30 text-white font-bold uppercase tracking-widest text-xs px-5 py-3 hover:bg-white/10 transition-colors"
            >
              Rifiuta
            </button>
          </div>
          <div className="mt-4 pt-3 border-t border-white/10 text-[11px] text-white/40 text-center">
            Sito realizzato da{" "}
            <a href={CREDIT.url} target="_blank" rel="noreferrer" data-testid="credit-cookie" className="text-white/70 underline hover:text-white">
              {CREDIT.name}
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
